module.exports = __webpack_public_path__ + "static/media/server-crash-2.06957ffe.png";